// @flow
import React, { Component } from "react";
import glamorous from "glamorous";
import cx from "classnames";
import t from "common/i18n";
import consts from "common/consts";
import { isMobile, trackDeviceOrientation } from "utils/domUtils";

import overlayImg from "../../../../assets/images/landscape-lock.svg";

type Props = {};
type State = {
	isLandscape: boolean,
};

const GOverlay = glamorous.div(
	cx(`flex flex-column items-center bg-source-bg landscape-overlay
    right-0 left-0`), {
		display: "flex",
		position: "absolute",
		top: `${consts.TAB_HEADER_HEIGHT}px`,
		height: "100%",
		zIndex: 10001,
	},
);

const GOverlayImage = glamorous.img({
	width: "128px",
	margin: "20px 0"
});

const GOverlayTitle = glamorous.div(cx("f2 b bg-window-c db"), { "margin-bottom": "10px" });

const GOverlayDescription = glamorous.div(cx("f4 bg-window-c"));

class MobileLandscapeOverlay extends Component<Props, State> {
	state = {
		isLandscape: false,
	};

	componentDidMount() {
		if (isMobile()) {
			this.orientationTracker = trackDeviceOrientation(this.onOrientationChange);
		}
	}

	componentWillUnmount() {
		if (this.orientationTracker) {
			this.orientationTracker(); // stop tracking orientation
			this.orientationTracker = null;
		}
	}

	onOrientationChange = (newVal: number) => {
		this.setState({
			isLandscape: (newVal === 90 || newVal === 180),
		});
	};

	orientationTracker = null;

	render() {
		return this.state.isLandscape
			? <GOverlay data-test="landscape-overlay">
				<GOverlayImage src={overlayImg}/>
				<GOverlayTitle>{t("landscape_overlay.title")}</GOverlayTitle>
				<GOverlayDescription>{t("landscape_overlay.description")}</GOverlayDescription>
			</GOverlay> : null;
	}
}

export default MobileLandscapeOverlay;
